import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar'; 
import Home from './components/Home';
import AboutUs from './components/Aboutus';
import WhyChooseUs from './components/WhyChooseUs';
import './App.css';
import Testimonial from './components/Testimonial';
import VideoSection from './components/VideoSection';
import Blog from './components/blog';
import Footer from './components/Footer';
import FAQSection from './components/Faq';
import AddFundsSection from './components/AddFundsSection';
import Services from './pages/Services';
import Platforms from './pages/Platforms';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';
import ElevenXPlayPage from './pages/ElevenXPlayPage';
import Laser247Page from './pages/Laser247';
import Cricket99 from './pages/Cricket99';
import CricketBettingPage from './pages/CricketBetting';
import TennisBettingPage from './pages/TennisBetting';
import FootballBettingPage from "./pages/FootballBetting";
import HorseRaceBettingPage from "./pages/horseRaceBetting";
import Casino from "./pages/Casino";
import IndianCardGamesBettingPage from "./pages/IndianCardGames";
import About from "./pages/AboutUs";
import SportsID from './pages/SportsId';
import Contact from './pages/Contact';
import Blogs from './pages/Blogs';
import BlogDetails from './pages/BlogDetails';
import StickyWhatsAppButton from './components/StickyWhatsAppButton';
import Compliance from './components/Compliance';
import SupportAndRules from './components/SupportAndRules';

function AppContent() {
  // Get the current route
  const location = useLocation();

  // List of routes where the WhatsApp icon should be hidden
  const hideWhatsAppRoutes = [
    '/contact',
    '/privacy-policy',
    '/terms-and-conditions',
    '/disclaimer',
    '/blogs',
    '/services',
    '/cricket-betting',
    '/tennis-betting',
    '/horse-race-betting',
    '/indian-card-games',
    '/football-betting',
    '/casino',
    '/platforms',
    '/11xplay',
    '/laser247',
    '/cricbet99',
    '/sports-id',
    '/about',
  ];

  // Check if the current route matches one of the routes in the hide list
  const hideWhatsAppIcon = hideWhatsAppRoutes.some(route => location.pathname.startsWith(route));

  return (
    <div className="App">
      <Navbar />
      <Routes>
        {/* Home route */}
        <Route
          path="/"
          element={
            <>
              <section id="home">
                <Home />
              </section>
              <section id="aboutus">
                <AboutUs />
              </section>
              <section id="blog">
                <Blog />
              </section>
              <section id="whychooseus">
                <WhyChooseUs />
              </section>
              <section id="testimonial">
                <Testimonial />
              </section>
              <section id="legal">
                <Compliance />
              </section>
              <section id="addfunds">
                <AddFundsSection />
              </section>
              <section id="videosection">
                <VideoSection />
              </section>
              <section id='support'>
                <SupportAndRules />
              </section>
              <section id="faq">
                <FAQSection />
              </section>
            </>
          }
        />

        <Route path="/contact" element={<Contact />} />
        
        {/* Service pages */}
        <Route path="/services" element={<Services />} />
        <Route path="/cricket-betting" element={<CricketBettingPage />} />
        <Route path="/tennis-betting" element={<TennisBettingPage />} />
        <Route path="/horse-race-betting" element={<HorseRaceBettingPage />} />
        <Route path="/indian-card-games" element={<IndianCardGamesBettingPage />} />
        <Route path="/football-betting" element={<FootballBettingPage />} />
        <Route path="/casino" element={<Casino />} />
        
        <Route path="/platforms" element={<Platforms />} />
        <Route path="/11xplay" element={<ElevenXPlayPage />} />
        <Route path="/laser247" element={<Laser247Page />} />
        <Route path="/cricbet99" element={<Cricket99 />} /> 

        <Route path="/about" element={<About />} />
        <Route path="/sports-id" element={<SportsID />} />

        {/* Terms and Privacy */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} /> 
        <Route path="/terms-and-conditions" element={<Terms />} />
        <Route path="/disclaimer" element={<Disclaimer />} />

        {/* Blogs */}
        <Route path="/blogs" element={<Blogs />} /> 
        <Route path="/blogs/:title" element={<BlogDetails />} /> 

        {/* Route for invalid paths */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* Conditional rendering of WhatsApp button */}
      {!hideWhatsAppIcon && <StickyWhatsAppButton />}
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
